export const formatCamelcase = ({text, upperCase}) => {
	// companyIdentify
}

export const formatUnderFromCamel = ({text, resultCase = 'upper'}) => {
	// companyIdentify
	let arr = text.split('');
	const result = arr.map(str => {
		if (str === str.toUpperCase()) {
			return `_${str.toLowerCase()}`;
		}
		return str;
	}).join('');
	
	if (resultCase === 'upper') {
		return result.toUpperCase();
	}
	return result;
}